import { AppRoot, Button } from '@telegram-apps/telegram-ui';
import React from 'react';
import { getButtonThemeColors } from '../helpers/theme';

type ButtonProps = React.ComponentProps<typeof Button>;

export const BaseButton: React.FC<ButtonProps> = ({ children, disabled, style, ...props }) => {
  const { backgroundColor, textColor } = getButtonThemeColors(!disabled);

  return (
    <AppRoot platform="base">
      <Button
        {...props}
        disabled={disabled}
        style={{
          ...style,
          ...(backgroundColor ? { backgroundColor } : {}),
          ...(textColor ? { color: textColor } : {}),
        }}
      >
        {children}
      </Button>
    </AppRoot>
  );
};
